import React, { Fragment } from 'react';
import getChildren from '../../utils/children';
import { BlockPropsBase } from '../..';

const SharedBlockRoot = (props: BlockPropsBase) => <Fragment>{getChildren(props.content)}</Fragment>
export default SharedBlockRoot;

